import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';

@Injectable({ providedIn: 'root' })
export class EEAOutputProjectSwashSwanResultsColdef {
  getColumnsDefinition(showResults: boolean, hideBufferDistance: boolean, isProjectOwnershipValid: boolean, isStep4: boolean = false): ColDef[] {
    const mitigationColumns = hideBufferDistance ? [] : [
      { headerName: 'Mitigation', field: 'mitigationName', width: 150, minWidth: 120, filter: 'agSetColumnFilter', sortable: true, resizable: true },
      { headerName: 'Width of vegetated\nbuffer zones (m)', field: 'bufferZone', width: 150, minWidth: 120, filter: 'agSetColumnFilter', sortable: true, resizable: true },
      { headerName: 'Spray drift options', field: 'sprayDriftOption', width: 150, minWidth: 120, filter: 'agSetColumnFilter', sortable: true, resizable: true },
      { headerName: 'Nozzle Reduction (%)', field: 'nozzleReduction', width: 150, minWidth: 120, filter: 'agSetColumnFilter', sortable: true, resizable: true },
      { headerName: 'Buffer width (m)', field: 'sprayDriftBuffer', width: 130, minWidth: 100, filter: 'agSetColumnFilter', sortable: true, resizable: true },
      { headerName: 'Distance for\nDeposition', field: 'distance', width: 130, minWidth: 100, filter: 'agSetColumnFilter', sortable: true, resizable: true },
    ];

    const baseColumns: any[] = [
      {
        headerName: 'General',
        children: [
          {
            headerName: 'SME Selection',
            field: 'eeaSmeSelection',
            width: 130,
            filter: 'agSetColumnFilter',
            sortable: true,
            checkboxSelection: isProjectOwnershipValid,
            hide: !isProjectOwnershipValid || !showResults,
            cellRenderer: 'checkBoxRenderer',
            cellRendererParams: { show: false },
            pinned: 'left',
          },
          {
            headerName: 'Run ID',
            field: 'runId',
            width: 120,
            minWidth: 100,
            filter: 'agSetColumnFilter',
            pinned: 'left',
            sortable: true,
            resizable: true,
          },
          {
            headerName: 'Model',
            field: 'model',
            width: 150,
            minWidth: 100,
            filter: 'agSetColumnFilter',
            pinned: 'left',
            sortable: true,
            resizable: true,
          },
        ],
      },
      {
        headerName: 'Application Pattern (GAP)',
        children: [
          { headerName: 'Application Scheme', field: 'applicationSchemeName', minWidth: 300, width: 300, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Crop', field: 'crop', minWidth: 160, width: 160, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Number Of Applications', field: 'applicationsNumber', minWidth: 140, width: 140, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Interval Between\nApplication (d)', field: 'applicationInterval', minWidth: 160, width: 160, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Rate\n(g/ha)', field: 'rate', minWidth: 100, width: 100, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'BBCH\n(Earliest)', field: 'BBCHEarliest', minWidth: 110, width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Scenario', field: 'scenearios', minWidth: 110, width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true, hide: isStep4 },
          { headerName: 'Water Type', field: 'waterType', minWidth: 110, width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true, hide: isStep4 },
          { headerName: 'Application Method', field: 'applicationMethod', minWidth: 135, width: 135, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Chemical Application Method', field: 'chemicalApplicationMethod', width: 200, minWidth: 200, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Soil Depth\nIncorporated (cm)', field: 'soilDepthIncorporated', width: 150, minWidth: 150, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          ...mitigationColumns,
        ],
      },
      {
        headerName: 'Endpoints',
        children: [
          { headerName: 'Endpoint Data Set', field: 'endpointsDataSetName', minWidth: 300, width: 300, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Parent', field: 'activeIngredient', width: 200, minWidth: 200, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Substance Name', field: 'substanceName', width: 210, minWidth: 210, filter: 'agSetColumnFilter', sortable: true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
          { headerName: 'Molecular\nWeight (g/mol)', field: 'molecularWeight', width: 130, minWidth: 130, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Saturated Vapour\nPressure (Pa)', field: 'saturatedVapourPressure', width: 145, minWidth: 145, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Solubility\nIn Water (mg/L)', field: 'solubilityInWater', width: 135, minWidth: 135, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Air Diffusion\nCoefficient (cm³/d)', field: 'airDiffusionCoefficient', width: 160, minWidth: 160, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Water Diffusion\nCoefficient (m²/d)', field: 'waterDifussionCoefficient', width: 145, minWidth: 145, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Kom\n(L/Kg)', field: 'kfom', width: 90, minWidth: 90, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Kfoc', field: 'kfoc', width: 90, minWidth: 90, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Freundlich Sorption Exponent In Soil (-)', field: 'freundlichSorptionExponentInSoil', width: 165, minWidth: 165, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Half-life\nIn Soil (d)', field: 'halfLifeInSoil', width: 100, minWidth: 100, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Half-life\nin water (d)', field: 'halfLifeInWater', width: 115, minWidth: 115, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Half-life\nin sediment (d)', field: 'halfLifeInSediment', width: 125, minWidth: 125, filter: 'agSetColumnFilter', sortable: true, resizable: true },
        ],
      },
    ];

    if (showResults) {
      const step4Columns = isStep4 ? [
        { headerName: 'Scenario', field: 'Scenarios', minWidth: 110, width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true },
        { headerName: 'Water Type', field: 'Waterbody', minWidth: 110, width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true },
      ] : [];

      baseColumns.push({
        headerName: 'Results Summary',
        children: [
          ...step4Columns,
          { headerName: 'Buffer Distance\n(m)', field: 'BufferDistance', width: 130, filter: 'agSetColumnFilter', sortable: true, resizable: true, hide: hideBufferDistance },
          { headerName: 'Dominant entry\nroute', field: 'DominantEntryRoute', width: 130, filter: 'agSetColumnFilter', sortable: true, resizable: true, wrapText: true },
          { headerName: 'Max PECsw\n(µg/L)', field: 'MaxPecSw', width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: '7 d - PECsw,\ntwa (µg/L)', field: 'SevenDaysPecSwTwa', width: 125, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Max PECsed\n(µg/kg)', field: 'MaxPecSed', width: 120, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: '21 d - PECsw\ntwa (µg/L)', field: 'PecSwTwa21Days', width: 125, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Global Max\nSW Date', field: 'GlobalMaxSwDate', width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true },
          { headerName: 'Application\nDate', field: 'ApplicationDate', width: 110, filter: 'agSetColumnFilter', sortable: true, resizable: true },
        ],
      } as ColDef);
    }

    return baseColumns;
  }
}
